import { AlertCircle, CheckCircle2, Info, TriangleAlert } from "lucide-react";

import { cn } from "../lib/cn";

const bannerToneMap = {
  info: {
    icon: Info,
    className: "border-border bg-muted/60 text-foreground",
    iconClass: "text-muted-foreground",
  },
  success: {
    icon: CheckCircle2,
    className: "border-[color-mix(in_oklch,var(--success)_20%,transparent)] bg-[color-mix(in_oklch,var(--success)_8%,transparent)] text-foreground",
    iconClass: "text-[var(--success)]",
  },
  warning: {
    icon: TriangleAlert,
    className: "border-[color-mix(in_oklch,var(--warning)_20%,transparent)] bg-[color-mix(in_oklch,var(--warning)_8%,transparent)] text-foreground",
    iconClass: "text-[var(--warning)]",
  },
  error: {
    icon: AlertCircle,
    className: "border-destructive/20 bg-destructive/8 text-foreground",
    iconClass: "text-destructive",
  },
} as const;

export interface BannerProps {
  tone?: keyof typeof bannerToneMap;
  title?: string;
  message: string;
  className?: string;
}

export function Banner({ className, message, title, tone = "info" }: BannerProps) {
  const { icon: Icon, className: toneClass, iconClass } = bannerToneMap[tone];

  return (
    <div
      className={cn(
        "flex items-start gap-3 rounded-lg border px-4 py-3 text-sm",
        toneClass,
        className,
      )}
      role="status"
    >
      <Icon className={cn("mt-0.5 size-4 shrink-0", iconClass)} />
      <div className="flex flex-col gap-0.5">
        {title ? <p className="font-medium">{title}</p> : null}
        <p className="leading-relaxed text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
